"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsReceivableAgingHeader = void 0;
const button_1 = require("client/components/material/button");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const select_1 = require("client/components/material/select");
const modal_1 = require("client/components/modal");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/reporting/store");
const store_2 = require("client/modules/sites/modules/sites-list/store");
const store_3 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const react_1 = require("react");
const React = require("react");
const util_1 = require("shared/util");
require("./accounts-receivable-aging-header.less");
let AccountsReceivableAgingHeader = class AccountsReceivableAgingHeader extends react_1.Component {
    constructor() {
        super(...arguments);
        this.filterText = "";
        this.siteId = 0;
        this.startDate = "";
        this.endDate = "";
        this.headerToggle = () => {
            store_1.reportsStore.editModal = !store_1.reportsStore.editModal;
        };
        this.handleLoader = () => {
            store_1.reportsStore.showLoader = !store_1.reportsStore.showLoader;
        };
        this.handleChangeSite = (id) => {
            this.siteId = Number(id);
        };
        this.handleSubmitQuery = async () => {
            this.handleLoader();
            this.headerToggle();
            await store_1.reportsStore.loadAccountsReceivableAging(this.siteId, this.startDate, this.endDate, true);
        };
        this.handleClickTodayStart = () => {
            const date = new Date().toDateString();
            this.startDate = moment(date).format("YYYY-MM-DD");
        };
        this.handleClickTodayEnd = () => {
            const date = new Date().toDateString();
            this.endDate = moment(date).format("YYYY-MM-DD");
        };
        this.handleClickClearStart = () => {
            this.startDate = "";
        };
        this.handleClickClearEnd = () => {
            this.endDate = "";
        };
        this.handleDatePickerChangeStart = (value) => {
            this.startDate = moment(value).format("YYYY-MM-DD");
        };
        this.handleDatePickerChangeEnd = (value) => {
            this.endDate = moment(value).format("YYYY-MM-DD");
        };
        this.handleCancel = () => {
            store_1.reportsStore.editModal = !store_1.reportsStore.editModal;
        };
    }
    componentWillMount() {
        if (store_3.usersStore.user.value &&
            store_3.usersStore.user.value.siteUser &&
            store_3.usersStore.user.value.siteId) {
            this.siteId = store_3.usersStore.user.value.siteId;
            this.handleChangeSite(String(this.siteId));
        }
        else {
            store_2.sitesListStore.loadSitesNoRelation();
        }
    }
    get availableOptions() {
        var _a;
        const options = [];
        const isImbUser = store_3.usersStore.user.value.user;
        if (isImbUser) {
            if (store_2.sitesListStore.sites.value) {
                options.push({ id: 0, label: "All Pharmacies", value: "0" });
                store_2.sitesListStore.sites.value.forEach((site, i) => {
                    const indexStandardizer = 1;
                    options.push({
                        id: i + indexStandardizer,
                        label: site.displayName || site.name,
                        value: site.id.toString()
                    });
                });
            }
        }
        else {
            const { site } = store_3.usersStore.user.value;
            const siteOption = {
                id: site.id,
                label: (_a = site.displayName) !== null && _a !== void 0 ? _a : site.name,
                value: site.id.toString()
            };
            options.push(siteOption);
        }
        return options;
    }
    render() {
        const { label = "Search", title, withDatePicker } = this.props;
        const buttons = [];
        buttons.push(React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"), React.createElement(button_1.MaterialButton, { className: "btnSubmit", onClick: this.handleSubmitQuery, primary: true, style: { marginLeft: "1em" } }, "Submit"));
        return (React.createElement("div", null,
            React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
                title && (React.createElement("div", { className: "filter-bar__title", style: { margin: "10px" } },
                    React.createElement("div", { className: "filter-bar__title-text" }, title))),
                React.createElement(button_1.MaterialButton, { onClick: () => this.headerToggle(), style: { margin: "10px" } }, "Query Options")),
            store_1.reportsStore.editModal ? (React.createElement(modal_1.Modal, { onCancel: this.headerToggle, height: "fit-content", top: "25%", width: "fit-content", buttons: buttons, overflowY: true },
                React.createElement("div", { className: "filter-bar" },
                    React.createElement("div", { className: "" },
                        React.createElement(select_1.MaterialSelect, { options: this.availableOptions, required: true, searchable: true, label: "Pharmacy", onSelect: this.handleChangeSite, onInputChange: e => {
                                util_1.pharmacyDropDownHandler({
                                    id: Number(this.siteId),
                                    search: e
                                });
                            }, value: String(this.siteId) || "", width: "100%" }),
                        React.createElement("br", null)),
                    React.createElement("div", { style: { display: "flex" } },
                        withDatePicker && (React.createElement("div", { className: "filter-bar", style: { paddingRight: "1em" } },
                            React.createElement("h3", null, "Start Date: "),
                            React.createElement(date_picker_1.MaterialDatePicker, { className: "filter-bar__date-picker", label: "Start Date", required: true, value: this.startDate || "", onChange: this.handleDatePickerChangeStart }),
                            React.createElement("div", { style: { display: "flex", marginTop: "1em" } },
                                React.createElement(button_1.MaterialButton, { className: "filter-bar__today-button", primary: true, onClick: this.handleClickTodayStart, style: { marginRight: "1em" } }, "Today"),
                                React.createElement(button_1.MaterialButton, { className: "filter-bar__clear-button", onClick: this.handleClickClearStart }, "Clear")))),
                        withDatePicker && (React.createElement("div", { className: "filter-bar" },
                            React.createElement("h3", null, "End Date: "),
                            React.createElement(date_picker_1.MaterialDatePicker, { className: "filter-bar__date-picker", label: "End Date", required: true, value: this.endDate || "", onChange: this.handleDatePickerChangeEnd }),
                            React.createElement("div", { style: { display: "flex", marginTop: "1em" } },
                                React.createElement(button_1.MaterialButton, { className: "filter-bar__today-button", primary: true, onClick: this.handleClickTodayEnd, style: { marginRight: "1em" } }, "Today"),
                                React.createElement(button_1.MaterialButton, { className: "filter-bar__clear-button", onClick: this.handleClickClearEnd }, "Clear")))))))) : null,
            store_1.reportsStore.showLoader ? React.createElement(ui_1.UiLoadingIndicator, null) : null));
    }
};
__decorate([
    mobx_1.observable
], AccountsReceivableAgingHeader.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], AccountsReceivableAgingHeader.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], AccountsReceivableAgingHeader.prototype, "startDate", void 0);
__decorate([
    mobx_1.observable
], AccountsReceivableAgingHeader.prototype, "endDate", void 0);
__decorate([
    mobx_1.computed
], AccountsReceivableAgingHeader.prototype, "availableOptions", null);
AccountsReceivableAgingHeader = __decorate([
    mobx_react_1.observer
], AccountsReceivableAgingHeader);
exports.AccountsReceivableAgingHeader = AccountsReceivableAgingHeader;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/accounts-receivable-aging-report/components/accounts-receivable-aging-header/accounts-receivable-aging-header.tsx
// module id = 3866
// module chunks = 0